import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let treatment_plan_id = useDataValue({
    context: 'selected',
    path: 'treatment_plan_id',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'treatment_plans',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'accept',
      treatment_plan_id,
    })
  }
}
